export default __webpack_public_path__ + "static/media/69-min.ef47c708.jpg";